import getters from "@/store/getters";

describe("getters", () => {
  const state = {
    route: "/home",
    mock: "mockedValue",
    isExceeded: false,
    refe: "refeValue",
    origen: "origenValue",
    paso1: { data: "paso1Data" },
    paso2: { data: "paso2Data" },
    paso3: { data: "paso3Data" },
    paso4: { data: "paso4Data" }
  };

  it("getRoute should return the current route", () => {
    const result = getters.getRoute(state)();
    expect(result).toBe("/home");
  });

  it("getMock should return the mocked value", () => {
    const result = getters.getMock(state)();
    expect(result).toBe("mockedValue");
  });

  it("getIsExceeded should return the isExceeded value", () => {
    const result = getters.getIsExceeded(state)();
    expect(result).toBe(false);
  });

  it("getOrigen should return the origen value with refe if available", () => {
    const result = getters.getOrigen(state)();
    expect(result).toBe("origenValue-refeValue");
  });

  it("getPaso1 should return the paso1 data", () => {
    const result = getters.getPaso1(state)();
    expect(result).toEqual({ data: "paso1Data" });
  });

  it("getPaso2 should return the paso2 data", () => {
    const result = getters.getPaso2(state)();
    expect(result).toEqual({ data: "paso2Data" });
  });

  it("getPaso3 should return the paso3 data", () => {
    const result = getters.getPaso3(state)();
    expect(result).toEqual({ data: "paso3Data" });
  });

  it("getPaso4 should return the paso4 data", () => {
    const result = getters.getPaso4(state)();
    expect(result).toEqual({ data: "paso4Data" });
  });
});
